import { countries } from 'country-flags-svg';
import AvatarImage from 'assets/images/avatar-image.png';
import { beautifyDate } from 'utils/dateUtils';
import classes from './ResumeTemplate5.module.scss';


const ResumeTemplate5 = ({ data }) => {
    return (
        <div className={classes.resume}>
            <div className={classes.leftColumn}>
                <div className={classes.contactInfo}>
                    <h2>Details about me</h2>
                    {data.contact_information.phone_number && (
                        <p><strong>Contact Number:</strong><br /> {data.contact_information.phone_number}</p>
                    )}
                    {data.contact_information.email && (
                        <p><strong>Email:</strong><br /> {data.contact_information.email}</p>
                    )}
                    {data?.about_me.residential_country_iso && (
                        <p><strong>Residential Location:</strong><br /> {countries.find((crty) => crty.iso2 === data?.about_me.residential_country_iso)?.name || ''}</p>
                    )}
                    {data.about_me.birth_date_beautify && (
                        <p><strong>Date of Birth:</strong><br /> {data.about_me.birth_date_beautify}</p>
                    )}
                </div>
                {data.about_me.languages?.length > 0 && (
                    <div className={classes.languages}>
                        <h2>Language(s)</h2>
                        {data.about_me.languages.map((lang) => (
                            <p><strong>{lang?.language?.name}</strong> ({lang?.proficiency?.proficiency})</p>
                        ))}
                    </div>
                )}
                {(data.skills.software_skills || data.skills.technical_skills) && (
                    <div className={classes.skills}>
                        <h2>Skills</h2>
                        {data.skills.software_skills && (
                            <div className='avoid-break'>
                                <h3>Software Skills</h3>
                                <p>{data.skills.software_skills}</p>
                            </div>
                        )}
                        {data.skills.technical_skills && (
                            <div className='avoid-break'>
                                <h3>Technical Skills</h3>
                                <p>{data.skills.technical_skills}</p>
                            </div>
                        )}
                    </div>
                )}
            </div>

            <div className={classes.rightColumn}>
                <div className={classes.aboutMe}>
                    <div className='d-flex align-items-center gap-2'>
                        <div className={classes.profilePicture}>
                            <img src={data.user.image ? data.user.image : AvatarImage.src} alt="Profile" />
                        </div>
                        <h1>{data.user.first_name} {data.user.last_name}</h1>
                    </div>
                    <div className='d-flex justify-content-between'>
                        <h2>About me</h2>
                    </div>
                    <p>
                        {data.about_me.about_me}
                    </p>
                </div>
                {data.work_experience?.work_experiences?.length > 0 && (
                    <div className={classes.workExperience}>
                        <h2>Work<br />Experience</h2>
                        {data.work_experience.work_experiences.map((exp) => (
                            <div className={`${classes.job} avoid-break`}>
                                <div>
                                    <h3><strong>{exp.job_title}</strong></h3>
                                    <p>{exp.company_name}</p>
                                    <p><span>{beautifyDate(exp.start_date)} - {exp.start_date ? beautifyDate(exp.start_date) : 'Now'}</span></p>
                                    <p><span>{exp.employment_status.status}</span></p>
                                </div>
                                <p>{exp.description}</p>
                            </div>
                        ))}
                    </div>
                )}

                {data.education?.education?.length > 0 && (
                    <div className={`${classes.educations} avoid-break`}>
                        <h2>Education</h2>
                        <div>
                            {data.education.education.map((edu) => (
                                <div className={classes.education}>
                                    <p><strong>{edu.university}</strong></p>
                                    <p>{edu.education_degree.degree}, {edu.field_or_major}</p>
                                    <br />
                                </div>
                            ))}
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
};

export default ResumeTemplate5;